import { trimAndAddAsterisk } from '../utility/QueryUtility';
import { commonDateParamMappings } from './common/mappings';

export const activityTrackingServiceMappings = [
  ...commonDateParamMappings,
  { path: 'size' },
  { path: 'dateFilter' },
  {
    paramKey: 'sort',
    transform: ({ orderBy, order }) => {
      const newOrder = order || 'asc';
      switch (orderBy) {
        case 'created':
          return `${orderBy},${newOrder}`;
        default:
          return orderBy ? `${orderBy}.keyword,${newOrder}` : null;
      }
    },
  },
  {
    path: 'search',
    transform: ({ search, searchValue }) => {
      if (searchValue) {
        return searchValue;
      }
      return search ? trimAndAddAsterisk(search) : null;
    },
  },
  {
    path: 'searchAfter',
    transform: ({ searchAfter }) => {
      if (Array.isArray(searchAfter)) {
        const copy = [...searchAfter];
        const id = copy.pop();
        const name = copy.join(',');

        return [name, id].join(encodeURIComponent(','));
      }

      return searchAfter;
    },
  },
  {
    path: 'pageRequested',
  },
  {
    path: 'apiClientId',
  },
];
